// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1d3In","title":"styles_title__MFy5k","subTitle":"styles_subTitle__qE_0n"};